import InfiniteScroll from "react-infinite-scroll-component";
import { Row, Col, Spin } from "antd";
import CustomCard from "./Card"; // adjust path as needed

import { useState } from "react";
import { loadAdjacentPages } from "../../interfaces/helpers/helpers";
import { useDispatch } from "react-redux";
import { loadRentals } from "../../interfaces/rentInterface";
import { resetPageData } from "../../features/rentSlice";
import { loadEvents } from "../../interfaces/eventInterface";
import CustomList from "./CustomList";
import { useEffect } from "react";
const configs = {
  rental: (dispatch, limit, availablePages , rentalFilters) =>
    loadRentals(
      dispatch,
      availablePages.size + 1,
      limit,
      availablePages,
      false,
      rentalFilters
    ),
  event: (dispatch , limit , availablePages , eventFilters ) =>
    loadEvents(dispatch , availablePages.size+1 ,limit , eventFilters),
};
const CardView = ({
  data=[],
  config,
  totalData,
  page,
  availablePages,
  limit,
  filters,
  view = "CardView",
  maxHeight ,
  callbacks={}
}) => {
  var dispatch = useDispatch();
  const [showEnd , setShowEnd] = useState(false)
  useEffect(() => {
  if (!(totalData - data.length > 0)) {
    setShowEnd(true);
    const t = setTimeout(() => setShowEnd(false), 3000);
    return () => clearTimeout(t);
  }
}, [data.length]);
  useEffect(()=>{

    if(availablePages && availablePages.size > 0 && totalData > data.length){
    if(document.getElementById("scrollableDiv")?.clientHeight > document.getElementsByClassName("infinite-scroll-component__outerdiv")[0]?.clientHeight){
      configs[config](dispatch , limit , availablePages , filters)
    }
  }
  },[availablePages,document.getElementById("scrollableDiv")?.clientHeight,document.getElementsByClassName("infinite-scroll-component__outerdiv")[0]?.clientHeight])

  return (
    <div
      id="scrollableDiv"
      style={{ overflowY: "auto", height: view == "CardView" ? "80vh" : "", maxHeight : maxHeight ? maxHeight : (view == "ListView" ? "50vh":"" ),overflowX: "hidden"}}
    >
      <InfiniteScroll
        dataLength={data.length}
        next={() => {
         configs[config](dispatch , limit , availablePages , filters)
        }}
        hasMore={totalData - data.length > 0}
        loader={<Spin />}
        endMessage={
          showEnd &&
          <p style={{ textAlign: "center", padding: "1rem" }}>
            <b>You’ve reached the end!</b>
          </p>
        }
        scrollableTarget="scrollableDiv"
        style={{ overflowX: "hidden", overflowY: "hidden"  }}
      >
        { view === "CardView" ?
        <Row gutter={[16, 16]} style={{margin:10}} wrap justify={"start"} align={"top"}>
          {data.map((item, idx) => (
            <Col
             key={idx}

      flex="1 1 240px"
      style={{ maxWidth: 340 }}
             >
              <CustomCard data={item} config={config} />
            </Col>
          ))}
        </Row> :
        <CustomList data={data} config={config} {...callbacks} />
        }

      </InfiniteScroll>
    </div>
  );
};

export default CardView;
